module.exports = __webpack_public_path__ + "img/banner-princiapal.29127dd5.png";